module.exports = __webpack_public_path__ + "scripts/brand-icons.woff?9f018d10";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/brand-icons.woff
// module id = 219
// module chunks = 1